import React from "react";
import { usePublicLang } from "../../../../config/i18n/public";
import ContactFooterBottomBar from "./ContactFooterBottomBar";
import ContactFooterForm from "./ContactFooterForm";
import ContactFooterHero from "./ContactFooterHero";
import ContactFooterInfoCard from "./ContactFooterInfoCard";
import ContactFooterLinks from "./ContactFooterLinks";

export default function ContactFooterSection() {
  const { copy } = usePublicLang();
  const c = copy.contact_footer;

  return (
    <section
      className="overflow-hidden bg-gradient-to-b from-[#0c0d12] via-[#09090d] to-[#06070a] text-[#f5f7fb]"
      aria-labelledby="contact-footer-title"
    >
      <div className="relative z-[1] mx-auto w-full max-w-[1480px] px-4 pb-5 pt-10 sm:px-6 lg:px-8 lg:pt-16">
        <ContactFooterHero
          eyebrow={c.eyebrow}
          titleLines={c.title_lines}
          description={c.description}
          actions={c.actions}
          actionsLabel={c.actions_label}
        />

        <div className="mt-9 grid grid-cols-1 gap-6 md:grid-cols-[minmax(0,0.92fr)_minmax(0,1.38fr)]">
          <ContactFooterInfoCard
            items={c.info_items}
            followLabel={c.follow_label}
            socialLinks={c.social_links}
            newsletter={c.newsletter}
            responseTime={c.response_time}
          />
          <ContactFooterForm form={c.form} />
        </div>

        <ContactFooterLinks brand={c.brand} columns={c.footer_columns} />
        <ContactFooterBottomBar
          copyright={c.bottom_bar.copyright}
          address={c.bottom_bar.address}
          links={c.bottom_bar.links}
        />
      </div>
    </section>
  );
}
